import React from "react";
import { Building2 } from "lucide-react";

/**
 * Branded header used at the top of every page-PDF capture.
 * Shows logo, business name + contact details on the left, page title + timestamp on the right.
 *
 * @param {object|null} business      Business object from /business/me
 * @param {string}      title         Page title (e.g. "Dashboard", "Reports & Insights")
 * @param {string=}     subtitle      Optional secondary line (e.g. active filter range)
 */
export function PrintHeader({ business, title, subtitle }) {
  const subParts = [];
  if (business?.address) subParts.push(business.address);
  const cityCountry = [business?.city, business?.country].filter(Boolean).join(", ");
  if (cityCountry) subParts.push(cityCountry);
  if (business?.phone) subParts.push(business.phone);
  if (business?.email) subParts.push(business.email);
  if (business?.tax_id) subParts.push(`Tax ID: ${business.tax_id}`);

  return (
    <div className="border-b border-[#E5E7EB] pb-3 mb-4 flex items-start justify-between gap-4" data-testid="pdf-print-header">
      <div className="flex items-start gap-3 min-w-0">
        {business?.logo_data_uri ? (
          <img src={business.logo_data_uri} alt="" className="w-12 h-12 object-contain shrink-0" crossOrigin="anonymous" />
        ) : (
          <div className="w-12 h-12 bg-[#F3F4F6] flex items-center justify-center shrink-0">
            <Building2 className="h-6 w-6 text-[#9CA3AF]" />
          </div>
        )}
        <div className="min-w-0">
          <div className="font-display text-xl font-bold text-[#0F172A] leading-tight">
            {business?.name || "Cashflow Ledger"}
          </div>
          {subParts.length > 0 && (
            <div className="text-[10px] text-[#6B7280] leading-snug mt-1">
              {subParts.join("  ·  ")}
            </div>
          )}
        </div>
      </div>
      <div className="text-right shrink-0">
        <div className="overline">Report</div>
        <div className="font-display text-base font-bold text-[#0F172A] leading-tight">{title}</div>
        <div className="text-[10px] text-[#6B7280] mt-1">Generated {new Date().toLocaleString()}</div>
        {subtitle && <div className="text-[10px] text-[#4B5563] mt-0.5">{subtitle}</div>}
      </div>
    </div>
  );
}
